import { useEffect } from 'react'
import { BackHandler, Platform } from 'react-native'

// Disables navigation back from a certain screen
const useDisableNavigatingBack = (navigation?: any, enabled: boolean = true) => {
  useEffect(() => {
    let backHandler: any = null
    if (enabled) {
      navigation?.setOptions({
        headerLeft: () => null,
        gestureEnabled: false
      })
      if (Platform.OS !== 'web') {
        backHandler = BackHandler.addEventListener('hardwareBackPress', () => true)
      }
    }
    return () => !!backHandler && backHandler.remove()
  }, [navigation, enabled])
}

export default useDisableNavigatingBack
